import React from "react";

import MaskedInput from "react-input-mask";

import { connect } from "react-redux";

import { SaveTable, Row } from "../DataTable.jsx";

import { ToggleOption } from "bootstrap-micro";
import { siteCreate } from "../store/sitesSlice.js";

export class AddPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            mac: "",
            key: "",
            nickname: "",
            notify: false
        }

    }
    validState() {
        return (
            (/^[a-f0-9]{12}$/).test(this.state.mac.replace(/:/g, "").toLowerCase()) &&
            (/^[0-9]{4}$/).test(this.state.key)
        )
    }
    onAddPanel() {
        this.props.siteCreate(this.state.mac, this.state.key, this.state.nickname, this.state.notify).then(() => {
            location.href="/#/";

        }, err => this.setState({ error: err.message }));
    }
    inpBind(key) {
        return {
            value: this.state[key],
            onChange: ev => this.setState({ [key]: ev.target.value })
        }
    }
    renderError() {
        if (this.state.error) {
            return <div className="col-md-6 col-md-offset-3">
                <div className="alert alert-danger" role="alert" id="error-message">{this.state.error}</div>
            </div>;
        }
    }
    render() {
        return <div className="container">
            <div className="row">
                {this.renderError()}
            </div>
            <div className="row">
                <div className="col-md-6 col-md-offset-3">
                    <p>The panel MAC address can be found by going to &quot;Network Setup&quot; &gt; Cloud on the panel. The MAC Address is in the bottom right of that screen.</p>
                </div>
            </div>
            <div className="row">

                <SaveTable disabled={!this.validState()} onSave={() => this.onAddPanel()}>
                    <Row label="MAC address (*)">
                        <MaskedInput
                            {...this.inpBind("mac") }
                            autoComplete="off"
                            required
                            id="mac"
                            type="text"
                            name="hwaddr"
                            className="form-control"
                            pattern="(?:[a-f0-9A-F]{2}){1}(?::[a-f0-9A-F]{2}){5}"
                            placeholder="e.g. 00:55:ff:65:66:c4"
                            title="To View On Panel - Go to User > Network > Cloud. MAC Address in bottom right."
                            formatChars={{ "h": "[a-f0-9A-F]" }}
                            mask="hh:hh:hh:hh:hh:hh"
                        />
                    </Row>
                    <Row label="Admin password (*)">
                        <MaskedInput
                            {...this.inpBind("key") }
                            autoComplete="off"
                            required
                            pattern="[0-9]{4}"
                            mask="9999"
                            name="panel-password"
                            className="form-control"
                            placeholder="e.g. 9965"
                            title="Please enter the panel's engineer password"
                        />
                    </Row>
                    <Row label="Site nickname">
                        <input
                            type="text"
                            className="form-control" {...this.inpBind("nickname") }
                            placeholder={this.state.mac}
                        />
                    </Row>
                    <Row label="Email notifications">
                        <ToggleOption
                            value={this.state.notify}
                            onClick={ notify => this.setState({ notify }) }
                        />
                    </Row>
                    <Row label="">
                        <small>(*) Denotes a required field.</small>
                    </Row>
                </SaveTable>
            </div>
        </div >
    }
}
export default connect(null, {
    siteCreate: siteCreate
})(AddPanel)